module.exports = __webpack_public_path__ + "img/store.c5423489.svg";